import { axiosHelper } from 'Services/AxiosHelper';
import { OnUpdateCustomerSecurityImageModel } from 'Models';
import { onUpdateCustomerSecurityImageReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnUpdateCustomerSecurityImage';

const onUpdateCustomerSecurityImage = async (
  params: onUpdateCustomerSecurityImageReqBodyData
): Promise<OnUpdateCustomerSecurityImageModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onUpdateCustomerSecurityImage;
